export const DocuSignTypes = {
  GET_DOCUSIGN_AUTH_URL: "GET_DOCUSIGN_AUTH_URL",
  GET_DOCUSIGN_AUTH_URL_SUCCESS: "GET_DOCUSIGN_AUTH_URL_SUCCESS",
  GET_DOCUSIGN_ACCESS_TOKEN: "GET_DOCUSIGN_ACCESS_TOKEN",
  GET_DOCUSIGN_ACCESS_TOKEN_SUCCESS: "GET_DOCUSIGN_ACCESS_TOKEN_SUCCESS",
}

export default DocuSignTypes